// extracted by mini-css-extract-plugin
module.exports = {"notAuthLang":"styles_notAuthLang__aE9nk","buttonWrapper":"styles_buttonWrapper__FMG_L","searchButton":"styles_searchButton__ZnBlH"};